import * as yup from "yup";

export type TiHi = { ti: number; hi: number };

const tiHiSchema = yup.number().min(1).max(32767).nullable();

export const ti = tiHiSchema
  .label("Ti")
  .test(
    "ti-required-if-hi",
    "Ti must be provided if Hi is provided.",
    function test(value) {
      const { hi: otherField } = this.parent as TiHi;
      if (value == null && otherField != null) return false;
      return true;
    },
  );

export const hi = tiHiSchema
  .label("Hi")
  .test(
    "hi-required-if-ti",
    "Hi must be provided if Ti is provided.",
    function test(value) {
      const { ti: otherField } = this.parent as TiHi;
      if (value == null && otherField != null) return false;
      return true;
    },
  );

const tiHi = yup
  .object()
  .shape({ ti, hi })
  .transform((value: TiHi | null | undefined) => {
    if (!value) return value;

    if (typeof value.ti !== "number" && typeof value.hi !== "number") {
      return null;
    }

    return value;
  })
  .nullable() as yup.ObjectSchema<TiHi>;

export default tiHi;
